import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MediaLibraryHttpService } from 'src/app/http/media-library-http.service';
import { EventsService } from 'src/app/services/events.service';
import { SharedService } from 'src/app/services/shared.service';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';
import { Location } from '@angular/common';
import { ProductHttpService } from 'src/app/http/product-http.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MediaModalComponent } from 'src/app/shared/modals/media-modal/media-modal.component';

@UntilDestroy()
@Component({
    selector: 'app-product-edit',
    templateUrl: './product-edit.component.html',
    styles: [],
})
export class ProductEditComponent implements OnInit {
    constructor(
        private fb: FormBuilder,
        private productHttpService: ProductHttpService,
        private sharedService: SharedService,
        private router: Router,
        public location: Location,
        private mediaLibraryHttpService: MediaLibraryHttpService,
        private modalService: NgbModal,
        private eventsService: EventsService,
        private activatedRoute: ActivatedRoute
    ) {}

    editProductForm = this.fb.group(
        {
            productId: [null],
            productName: [null, Validators.required],
            sectionId: [null, Validators.required],
            price: [null, Validators.required],
            desc: [null],
            assetId: [null],
            isPublished: [false],
            markAsNew: [false],
            hasOffer: [false, { updateOn: 'change' }],
            offerFrom: [null],
            offerTo: [null],
            offerType: ['DISCOUNT'],
            offerValue: [null],
            stock: [null],
            limitPerOrder: [null],
            limitPerDay: [null],
            specialDiscount: [null],
            index: [null],
        },
        { updateOn: 'submit' }
    );

    product: any;

    sections: any[] = [];

    selectAsset: any;

    formBusy: boolean;

    offerType: any[] = [
        {
            name: 'Discount',
            id: 'DISCOUNT',
        },
        {
            name: 'Value',
            id: 'VALUE',
        },
    ];

    ngOnInit(): void {
        this.routeData();
        this.eventsSub();
    }

    eventsSub() {
        this.eventsService.trigger.pipe(untilDestroyed(this)).subscribe((data) => {
            if (data.name === 'selectedAsset') {
                const selected = data.value.slice(-1).pop();
                if (selected) {
                    this.selectAsset = selected;
                    this.editProductForm.controls['assetId'].setValue(selected.assetId);
                }
            }
        });
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.product = data.data[0];
            this.sections = data.data[1];
            this.patchForm(data.data[0]);
        });
    }

    patchForm(item: any) {
        this.editProductForm.patchValue(item);
        if (item.asset) {
            this.selectAsset = item.asset;
        }
    }

    onSubmit() {
        this.editProductForm.markAsTouched();
        if (this.editProductForm.valid) {
            this.formBusy = true;
            this.productHttpService.editProduct(this.editProductForm.value).subscribe(
                (result) => {
                    this.router.navigateByUrl('product-list', {
                        state: { hasState: true, type: 'success', message: 'Product Edited successfully' },
                    });
                },
                (error) => {
                    this.formBusy = false;
                    this.editProductForm.setErrors({ exists: true });
                }
            );
        }
    }

    openMedia() {
        this.mediaLibraryHttpService.getAllFolders().subscribe((folders) => {
            let media = this.modalService.open(MediaModalComponent, { size: 'xl', windowClass: 'media-library' });
            media.componentInstance.folders = folders;
        });
    }

    clearImages() {
        this.selectAsset = null;
        this.editProductForm.controls['assetId'].setValue(null);
    }

    confirmDelete(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = 'Delete';
        confirm.componentInstance.messageLabel = 'Are you sure you want to delete this content item?';
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.delete(item);
                }
            },
            () => {}
        );
    }

    delete(item: any) {
        this.productHttpService.deleteProduct(item.productId).subscribe(() => {
            this.router.navigateByUrl('product-list', {
                state: { hasState: true, type: 'success', message: 'Product Deleted successfully' },
            });
        });
    }

    ngOnDestroy(): void {
        this.eventsService.trigger.next({ name: null, value: null });
    }
}
